<script>
  export let value = '';
</script>


<style>
	select {
		text-align: center;
		justify-content: center;
		-moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
		display: inline-flex;
		align-items: center;
		overflow: hidden;
		height: 44px;
		padding: 0 16px 0 8px;
		color: rgb(80, 80, 80);
		border-radius: 8px;
		background: transparent;
		border: 2px solid currentColor;
		margin: 0;
		background-position: center right 2px;
		background-repeat: no-repeat;
		background-image:url('data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDMyIDMyIj48cGF0aCBkPSJNMTYuMDAzIDE4LjYyNmw3LjA4MS03LjA4MUwyNSAxMy40NmwtOC45OTcgOC45OTgtOS4wMDMtOSAxLjkxNy0xLjkxNnoiLz48L3N2Zz4=');
	}
</style>
<select bind:value={value} on:input on:blur on:focus {...$$restProps}><slot /></select>